module.exports = __webpack_public_path__ + "static/media/ipc_bg_corporate.4f130fed.svg";